"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countryCodes = exports.currencyCodes = exports.storeSelectorFullPath = exports.storeSelectorCountries = exports.localesUrlMap = exports.countryNames = exports.defaultCountryCodes = exports.localesEnvMap = exports.isLocaleOrLanguage = exports.isLanguage = exports.isLocale = exports.defaultLocale = exports.envLocales = exports.locales = exports.languages = void 0;
const types_1 = require("@ct/types");
exports.languages = ['en'];
exports.locales = Object.values(types_1.Locale).map((locale) => locale.toLowerCase());
exports.envLocales = ['EN_GB'];
exports.defaultLocale = 'en-GB';
function isLocale(locale) {
    return exports.locales.includes(locale);
}
exports.isLocale = isLocale;
function isLanguage(locale) {
    return exports.languages.includes(locale);
}
exports.isLanguage = isLanguage;
function isLocaleOrLanguage(locale) {
    return isLocale(locale) || isLanguage(locale);
}
exports.isLocaleOrLanguage = isLocaleOrLanguage;
exports.localesEnvMap = {
    'en-GB': 'EN_GB',
};
exports.defaultCountryCodes = {
    'en-GB': '44',
};
exports.countryNames = {
    'en-GB': 'United Kingdom',
};
exports.localesUrlMap = {
    'en-GB': '/',
};
exports.storeSelectorCountries = ['gb'];
exports.storeSelectorFullPath = {
    'ae-gb': 'https://[host]',
};
exports.currencyCodes = {
    GB: 'GBP',
};
exports.countryCodes = [
    {
        country: 'United Arab Emirates',
        countryCode: 971,
        isoCode: 'AE',
        countryAr: 'الإمارات العربية المتحدة',
    },
    {
        country: 'Saudi Arabia',
        countryCode: 966,
        isoCode: 'SA',
        countryAr: 'السعودية',
    },
    {
        country: 'Afghanistan',
        countryCode: 93,
        isoCode: 'AF',
        countryAr: 'أفغانستان',
    },
    {
        country: 'Albania',
        countryCode: 355,
        isoCode: 'AL',
        countryAr: 'ألبانيا',
    },
    {
        country: 'Algeria',
        countryCode: 213,
        isoCode: 'DZ',
        countryAr: 'الجزائر',
    },
    {
        country: 'American Samoa',
        countryCode: '1-684',
        isoCode: 'AS',
        countryAr: 'ساموا الأمريكية',
    },
    {
        country: 'Andorra',
        countryCode: 376,
        isoCode: 'AD',
        countryAr: 'أندورا',
    },
    {
        country: 'Angola',
        countryCode: 244,
        isoCode: 'AO',
        countryAr: 'أنغولا',
    },
    {
        country: 'Anguilla',
        countryCode: '1-264',
        isoCode: 'AI',
        countryAr: 'آنگویلا',
    },
    {
        country: 'Antarctica',
        countryCode: 672,
        isoCode: 'AQ',
        countryAr: 'القارة القطبية الجنوبية',
    },
    {
        country: 'Antigua and Barbuda',
        countryCode: '1-268',
        isoCode: 'AG',
        countryAr: 'أنتيغوا وباربودا',
    },
    {
        country: 'Argentina',
        countryCode: 54,
        isoCode: 'AR',
        countryAr: 'الأرجنتين',
    },
    {
        country: 'Armenia',
        countryCode: 374,
        isoCode: 'AM',
        countryAr: 'أرمينيا',
    },
    {
        country: 'Aruba',
        countryCode: 297,
        isoCode: 'AW',
        countryAr: 'أروبا',
    },
    {
        country: 'Australia',
        countryCode: 61,
        isoCode: 'AU',
        countryAr: 'أستراليا',
    },
    {
        country: 'Austria',
        countryCode: 43,
        isoCode: 'AT',
        countryAr: 'النمسا',
    },
    {
        country: 'Azerbaijan',
        countryCode: 994,
        isoCode: 'AZ',
        countryAr: 'أذربيجان',
    },
    {
        country: 'Bahamas',
        countryCode: '1-242',
        isoCode: 'BS',
        countryAr: 'باهاماس',
    },
    {
        country: 'Bahrain',
        countryCode: 973,
        isoCode: 'BH',
        countryAr: 'البحرين',
    },
    {
        country: 'Bangladesh',
        countryCode: 880,
        isoCode: 'BD',
        countryAr: 'بنغلاديش',
    },
    {
        country: 'Barbados',
        countryCode: '1-246',
        isoCode: 'BB',
        countryAr: 'باربادوس',
    },
    {
        country: 'Belarus',
        countryCode: 375,
        isoCode: 'BY',
        countryAr: 'بيلاروس',
    },
    {
        country: 'Belgium',
        countryCode: 32,
        isoCode: 'BE',
        countryAr: 'بلجيكا',
    },
    {
        country: 'Belize',
        countryCode: 501,
        isoCode: 'BZ',
        countryAr: 'بليز',
    },
    {
        country: 'Benin',
        countryCode: 229,
        isoCode: 'BJ',
        countryAr: 'بنين',
    },
    {
        country: 'Bermuda',
        countryCode: '1-441',
        isoCode: 'BM',
        countryAr: 'برمودا',
    },
    {
        country: 'Bhutan',
        countryCode: 975,
        isoCode: 'BT',
        countryAr: 'بوتان',
    },
    {
        country: 'Bolivia',
        countryCode: 591,
        isoCode: 'BO',
        countryAr: 'بوليفيا',
    },
    {
        country: 'Bosnia and Herzegovina',
        countryCode: 387,
        isoCode: 'BA',
        countryAr: 'البوسنة والهرسك',
    },
    {
        country: 'Botswana',
        countryCode: 267,
        isoCode: 'BW',
        countryAr: 'بوتسوانا',
    },
    {
        country: 'Brazil',
        countryCode: 55,
        isoCode: 'BR',
        countryAr: 'البرازيل',
    },
    {
        country: 'British Indian Ocean Territory',
        countryCode: 246,
        isoCode: 'IO',
        countryAr: 'إقليم المحيط البريطاني الهندي',
    },
    {
        country: 'British Virgin Islands',
        countryCode: '1-284',
        isoCode: 'VG',
        countryAr: 'جزر فيرجن البريطانية',
    },
    {
        country: 'Brunei',
        countryCode: 673,
        isoCode: 'BN',
        countryAr: 'بروناي',
    },
    {
        country: 'Bulgaria',
        countryCode: 359,
        isoCode: 'BG',
        countryAr: 'بلغاريا',
    },
    {
        country: 'Burkina Faso',
        countryCode: 226,
        isoCode: 'BF',
        countryAr: 'بوركينا فاسو',
    },
    {
        country: 'Burundi',
        countryCode: 257,
        isoCode: 'BI',
        countryAr: 'بوروندي',
    },
    {
        country: 'Cambodia',
        countryCode: 855,
        isoCode: 'KH',
        countryAr: 'كمبوديا',
    },
    {
        country: 'Cameroon',
        countryCode: 237,
        isoCode: 'CM',
        countryAr: 'الكاميرون',
    },
    {
        country: 'Canada',
        countryCode: 1,
        isoCode: 'CA',
        countryAr: 'كندا',
    },
    {
        country: 'Cape Verde',
        countryCode: 238,
        isoCode: 'CV',
        countryAr: 'الرأس الأخضر',
    },
    {
        country: 'Cayman Islands',
        countryCode: '1-345',
        isoCode: 'KY',
        countryAr: 'جزر كايمان',
    },
    {
        country: 'Central African Republic',
        countryCode: 236,
        isoCode: 'CF',
        countryAr: 'جمهورية أفريقيا الوسطى',
    },
    {
        country: 'Chad',
        countryCode: 235,
        isoCode: 'TD',
        countryAr: 'تشاد',
    },
    {
        country: 'Chile',
        countryCode: 56,
        isoCode: 'CL',
        countryAr: 'تشيلي',
    },
    {
        country: 'China',
        countryCode: 86,
        isoCode: 'CN',
        countryAr: 'الصين',
    },
    {
        country: 'Christmas Island',
        countryCode: 61,
        isoCode: 'CX',
        countryAr: 'جزيرة الكريسماس',
    },
    {
        country: 'Cocos Islands',
        countryCode: 61,
        isoCode: 'CC',
        countryAr: 'جزر كوكوس',
    },
    {
        country: 'Colombia',
        countryCode: 57,
        isoCode: 'CO',
        countryAr: 'كولومبيا',
    },
    {
        country: 'Comoros',
        countryCode: 269,
        isoCode: 'KM',
        countryAr: 'جزر القمر',
    },
    {
        country: 'Cook Islands',
        countryCode: 682,
        isoCode: 'CK',
        countryAr: 'جزر كوك',
    },
    {
        country: 'Costa Rica',
        countryCode: 506,
        isoCode: 'CR',
        countryAr: 'كوستاريكا',
    },
    {
        country: 'Croatia',
        countryCode: 385,
        isoCode: 'HR',
        countryAr: 'كرواتيا',
    },
    {
        country: 'Cuba',
        countryCode: 53,
        isoCode: 'CU',
        countryAr: 'كوبا',
    },
    {
        country: 'Curacao',
        countryCode: 599,
        isoCode: 'CW',
        countryAr: 'كوراكاو',
    },
    {
        country: 'Cyprus',
        countryCode: 357,
        isoCode: 'CY',
        countryAr: 'قبرص',
    },
    {
        country: 'Czech Republic',
        countryCode: 420,
        isoCode: 'CZ',
        countryAr: 'جمهورية التشيك',
    },
    {
        country: 'Democratic Republic of the Congo (CD)',
        countryCode: 243,
        isoCode: 'CD',
        countryAr: 'جمهورية الكونغو الديمقراطية',
    },
    {
        country: 'Democratic Republic of the Congo (CG)',
        countryCode: 242,
        isoCode: 'CG',
        countryAr: 'جمهورية الكونغو',
    },
    {
        country: 'Denmark',
        countryCode: 45,
        isoCode: 'DK',
        countryAr: 'الدنمارك',
    },
    {
        country: 'Djibouti',
        countryCode: 253,
        isoCode: 'DJ',
        countryAr: 'جيبوتي',
    },
    {
        country: 'Dominica',
        countryCode: '1-767',
        isoCode: 'DM',
        countryAr: 'دومينيكا',
    },
    {
        country: 'Dominican Republic',
        countryCode: '1-809, 1-829, 1-849',
        isoCode: 'DO',
        countryAr: 'جمهورية الدومينيكان',
    },
    {
        country: 'East Timor',
        countryCode: 670,
        isoCode: 'TL',
        countryAr: 'تيمور الشرقية',
    },
    {
        country: 'Ecuador',
        countryCode: 593,
        isoCode: 'EC',
        countryAr: 'الإكوادور',
    },
    {
        country: 'Egypt',
        countryCode: 20,
        isoCode: 'EG',
        countryAr: 'مصر',
    },
    {
        country: 'El Salvador',
        countryCode: 503,
        isoCode: 'SV',
        countryAr: 'السلفادور',
    },
    {
        country: 'Equatorial Guinea',
        countryCode: 240,
        isoCode: 'GQ',
        countryAr: 'غينيا الاستوائية',
    },
    {
        country: 'Eritrea',
        countryCode: 291,
        isoCode: 'ER',
        countryAr: 'إريتريا',
    },
    {
        country: 'Estonia',
        countryCode: 372,
        isoCode: 'EE',
        countryAr: 'إستونيا',
    },
    {
        country: 'Ethiopia',
        countryCode: 251,
        isoCode: 'ET',
        countryAr: 'إثيوبيا',
    },
    {
        country: 'Falkland Islands',
        countryCode: 500,
        isoCode: 'FK',
        countryAr: 'جزر فوكلاند',
    },
    {
        country: 'Faroe Islands',
        countryCode: 298,
        isoCode: 'FO',
        countryAr: 'جزر فاروس',
    },
    {
        country: 'Fiji',
        countryCode: 679,
        isoCode: 'FJ',
        countryAr: 'فيجي',
    },
    {
        country: 'Finland',
        countryCode: 358,
        isoCode: 'FI',
        countryAr: 'فنلندا',
    },
    {
        country: 'France',
        countryCode: 33,
        isoCode: 'FR',
        countryAr: 'فرنسا',
    },
    {
        country: 'French Polynesia',
        countryCode: 689,
        isoCode: 'PF',
        countryAr: 'بولينيزيا الفرنسية',
    },
    {
        country: 'Gabon',
        countryCode: 241,
        isoCode: 'GA',
        countryAr: 'الغابون',
    },
    {
        country: 'Gambia',
        countryCode: 220,
        isoCode: 'GM',
        countryAr: 'غامبيا',
    },
    {
        country: 'Georgia',
        countryCode: 995,
        isoCode: 'GE',
        countryAr: 'جورجيا',
    },
    {
        country: 'Germany',
        countryCode: 49,
        isoCode: 'DE',
        countryAr: 'ألمانيا',
    },
    {
        country: 'Ghana',
        countryCode: 233,
        isoCode: 'GH',
        countryAr: 'غانا',
    },
    {
        country: 'Gibraltar',
        countryCode: 350,
        isoCode: 'GI',
        countryAr: 'جبل طارق',
    },
    {
        country: 'Greece',
        countryCode: 30,
        isoCode: 'GR',
        countryAr: 'اليونان',
    },
    {
        country: 'Greenland',
        countryCode: 299,
        isoCode: 'GL',
        countryAr: 'الأرض الخضراء',
    },
    {
        country: 'Grenada',
        countryCode: '1-473',
        isoCode: 'GD',
        countryAr: 'غرينادا',
    },
    {
        country: 'Guam',
        countryCode: '1-671',
        isoCode: 'GU',
        countryAr: 'غوام',
    },
    {
        country: 'Guatemala',
        countryCode: 502,
        isoCode: 'GT',
        countryAr: 'غواتيمالا',
    },
    {
        country: 'Guernsey',
        countryCode: '44-1481',
        isoCode: 'GG',
        countryAr: 'غيرنسي',
    },
    {
        country: 'Guinea',
        countryCode: 224,
        isoCode: 'GN',
        countryAr: 'غينيا',
    },
    {
        country: 'Guinea-Bissau',
        countryCode: 245,
        isoCode: 'GW',
        countryAr: 'غينيا بيساو',
    },
    {
        country: 'Guyana',
        countryCode: 592,
        isoCode: 'GY',
        countryAr: 'غيانا',
    },
    {
        country: 'Haiti',
        countryCode: 509,
        isoCode: 'HT',
        countryAr: 'هايتي',
    },
    {
        country: 'Honduras',
        countryCode: 504,
        isoCode: 'HN',
        countryAr: 'هندوراس',
    },
    {
        country: 'Hong Kong',
        countryCode: 852,
        isoCode: 'HK',
        countryAr: 'هونج كونج',
    },
    {
        country: 'Hungary',
        countryCode: 36,
        isoCode: 'HU',
        countryAr: 'المجر',
    },
    {
        country: 'Iceland',
        countryCode: 354,
        isoCode: 'IS',
        countryAr: 'آيسلندا',
    },
    {
        country: 'India',
        countryCode: 91,
        isoCode: 'IN',
        countryAr: 'الهند',
    },
    {
        country: 'Indonesia',
        countryCode: 62,
        isoCode: 'ID',
        countryAr: 'إندونيسيا',
    },
    {
        country: 'Iran',
        countryCode: 98,
        isoCode: 'IR',
        countryAr: 'إيران',
    },
    {
        country: 'Iraq',
        countryCode: 964,
        isoCode: 'IQ',
        countryAr: 'العراق',
    },
    {
        country: 'Ireland',
        countryCode: 353,
        isoCode: 'IE',
        countryAr: 'أيرلندا',
    },
    {
        country: 'Isle of Man',
        countryCode: '44-1624',
        isoCode: 'IM',
        countryAr: 'جزيرة مان',
    },
    {
        country: 'Israel',
        countryCode: 972,
        isoCode: 'IL',
        countryAr: 'إسرائيل',
    },
    {
        country: 'Italy',
        countryCode: 39,
        isoCode: 'IT',
        countryAr: 'إيطاليا',
    },
    {
        country: 'Ivory Coast',
        countryCode: 225,
        isoCode: 'CI',
        countryAr: 'ساحل العاج',
    },
    {
        country: 'Jamaica',
        countryCode: '1-876',
        isoCode: 'JM',
        countryAr: 'جامايكا',
    },
    {
        country: 'Japan',
        countryCode: 81,
        isoCode: 'JP',
        countryAr: 'اليابان',
    },
    {
        country: 'Jersey',
        countryCode: '44-1534',
        isoCode: 'JE',
        countryAr: 'جيرسي',
    },
    {
        country: 'Jordan',
        countryCode: 962,
        isoCode: 'JO',
        countryAr: 'الأردن',
    },
    {
        country: 'Kazakhstan',
        countryCode: 7,
        isoCode: 'KZ',
        countryAr: 'كازاخستان',
    },
    {
        country: 'Kenya',
        countryCode: 254,
        isoCode: 'KE',
        countryAr: 'كينيا',
    },
    {
        country: 'Kiribati',
        countryCode: 686,
        isoCode: 'KI',
        countryAr: 'كيريباتي',
    },
    {
        country: 'Kosovo',
        countryCode: 383,
        isoCode: 'XK',
        countryAr: 'كوسوفو',
    },
    {
        country: 'Kuwait',
        countryCode: 965,
        isoCode: 'KW',
        countryAr: 'الكويت',
    },
    {
        country: 'Kyrgyzstan',
        countryCode: 996,
        isoCode: 'KG',
        countryAr: 'قيرغيزستان',
    },
    {
        country: 'Laos',
        countryCode: 856,
        isoCode: 'LA',
        countryAr: 'لاوس',
    },
    {
        country: 'Latvia',
        countryCode: 371,
        isoCode: 'LV',
        countryAr: 'لاتفيا',
    },
    {
        country: 'Lebanon',
        countryCode: 961,
        isoCode: 'LB',
        countryAr: 'لبنان',
    },
    {
        country: 'Lesotho',
        countryCode: 266,
        isoCode: 'LS',
        countryAr: 'ليسوتو',
    },
    {
        country: 'Liberia',
        countryCode: 231,
        isoCode: 'LR',
        countryAr: 'ليبيريا',
    },
    {
        country: 'Libya',
        countryCode: 218,
        isoCode: 'LY',
        countryAr: 'ليبيا',
    },
    {
        country: 'Liechtenstein',
        countryCode: 423,
        isoCode: 'LI',
        countryAr: 'ليختنشتاين',
    },
    {
        country: 'Lithuania',
        countryCode: 370,
        isoCode: 'LT',
        countryAr: 'ليتوانيا',
    },
    {
        country: 'Luxembourg',
        countryCode: 352,
        isoCode: 'LU',
        countryAr: 'لوكسمبورغ',
    },
    {
        country: 'Macau',
        countryCode: 853,
        isoCode: 'MO',
        countryAr: 'ماكاو',
    },
    {
        country: 'Macedonia',
        countryCode: 389,
        isoCode: 'MK',
        countryAr: 'مقدونيا',
    },
    {
        country: 'Madagascar',
        countryCode: 261,
        isoCode: 'MG',
        countryAr: 'مدغشقر',
    },
    {
        country: 'Malawi',
        countryCode: 265,
        isoCode: 'MW',
        countryAr: 'مالاوي',
    },
    {
        country: 'Malaysia',
        countryCode: 60,
        isoCode: 'MY',
        countryAr: 'ماليزيا',
    },
    {
        country: 'Maldives',
        countryCode: 960,
        isoCode: 'MV',
        countryAr: 'جزر المالديف',
    },
    {
        country: 'Mali',
        countryCode: 223,
        isoCode: 'ML',
        countryAr: 'مالي',
    },
    {
        country: 'Malta',
        countryCode: 356,
        isoCode: 'MT',
        countryAr: 'مالطا',
    },
    {
        country: 'Marshall Islands',
        countryCode: 692,
        isoCode: 'MH',
        countryAr: 'جزر مارشال',
    },
    {
        country: 'Mauritania',
        countryCode: 222,
        isoCode: 'MR',
        countryAr: 'موريتانيا',
    },
    {
        country: 'Mauritius',
        countryCode: 230,
        isoCode: 'MU',
        countryAr: 'موريشيوس',
    },
    {
        country: 'Mayotte',
        countryCode: 262,
        isoCode: 'YT',
        countryAr: 'مایوٹ',
    },
    {
        country: 'Mexico',
        countryCode: 52,
        isoCode: 'MX',
        countryAr: 'المكسيك',
    },
    {
        country: 'Micronesia',
        countryCode: 691,
        isoCode: 'FM',
        countryAr: 'ولايات ميكرونيسيا المتحدة',
    },
    {
        country: 'Moldova',
        countryCode: 373,
        isoCode: 'MD',
        countryAr: 'مولدوفا',
    },
    {
        country: 'Monaco',
        countryCode: 377,
        isoCode: 'MC',
        countryAr: 'موناكو',
    },
    {
        country: 'Mongolia',
        countryCode: 976,
        isoCode: 'MN',
        countryAr: 'منغوليا',
    },
    {
        country: 'Montenegro',
        countryCode: 382,
        isoCode: 'ME',
        countryAr: 'الجبل الأسود',
    },
    {
        country: 'Montserrat',
        countryCode: '1-664',
        isoCode: 'MS',
        countryAr: 'مونتسيرات',
    },
    {
        country: 'Morocco',
        countryCode: 212,
        isoCode: 'MA',
        countryAr: 'المغرب',
    },
    {
        country: 'Mozambique',
        countryCode: 258,
        isoCode: 'MZ',
        countryAr: 'موزمبيق',
    },
    {
        country: 'Myanmar',
        countryCode: 95,
        isoCode: 'MM',
        countryAr: 'ميانمار',
    },
    {
        country: 'Namibia',
        countryCode: 264,
        isoCode: 'NA',
        countryAr: 'ناميبيا',
    },
    {
        country: 'Nauru',
        countryCode: 674,
        isoCode: 'NR',
        countryAr: 'ناورو',
    },
    {
        country: 'Nepal',
        countryCode: 977,
        isoCode: 'NP',
        countryAr: 'نيبال',
    },
    {
        country: 'Netherlands',
        countryCode: 31,
        isoCode: 'NL',
        countryAr: 'هولندا',
    },
    {
        country: 'Netherlands Antilles',
        countryCode: 599,
        isoCode: 'AN',
        countryAr: 'جزر الأنتيل الهولندية',
    },
    {
        country: 'New Caledonia',
        countryCode: 687,
        isoCode: 'NC',
        countryAr: 'كاليدونيا الجديدة',
    },
    {
        country: 'New Zealand',
        countryCode: 64,
        isoCode: 'NZ',
        countryAr: 'نيوزيلندا',
    },
    {
        country: 'Nicaragua',
        countryCode: 505,
        isoCode: 'NI',
        countryAr: 'نيكاراغوا',
    },
    {
        country: 'Niger',
        countryCode: 227,
        isoCode: 'NE',
        countryAr: 'النيجر',
    },
    {
        country: 'Nigeria',
        countryCode: 234,
        isoCode: 'NG',
        countryAr: 'نيجيريا',
    },
    {
        country: 'Niue',
        countryCode: 683,
        isoCode: 'NU',
        countryAr: 'نييوي',
    },
    {
        country: 'North Korea',
        countryCode: 850,
        isoCode: 'KP',
        countryAr: 'كوريا الشمالية',
    },
    {
        country: 'Northern Mariana Islands',
        countryCode: '1-670',
        isoCode: 'MP',
        countryAr: 'جزر مريانا الشمالية',
    },
    {
        country: 'Norway',
        countryCode: 47,
        isoCode: 'NO',
        countryAr: 'النرويج',
    },
    {
        country: 'Oman',
        countryCode: 968,
        isoCode: 'OM',
        countryAr: 'عمان',
    },
    {
        country: 'Pakistan',
        countryCode: 92,
        isoCode: 'PK',
        countryAr: 'باكستان',
    },
    {
        country: 'Palau',
        countryCode: 680,
        isoCode: 'PW',
        countryAr: 'بالاو',
    },
    {
        country: 'Palestine',
        countryCode: 970,
        isoCode: 'PS',
        countryAr: 'فلسطين',
    },
    {
        country: 'Panama',
        countryCode: 507,
        isoCode: 'PA',
        countryAr: 'بنما',
    },
    {
        country: 'Papua New Guinea',
        countryCode: 675,
        isoCode: 'PG',
        countryAr: 'بابوا غينيا الجديدة',
    },
    {
        country: 'Paraguay',
        countryCode: 595,
        isoCode: 'PY',
        countryAr: 'باراغواي',
    },
    {
        country: 'Peru',
        countryCode: 51,
        isoCode: 'PE',
        countryAr: 'بيرو',
    },
    {
        country: 'Philippines',
        countryCode: 63,
        isoCode: 'PH',
        countryAr: 'الفلبين',
    },
    {
        country: 'Pitcairn',
        countryCode: 64,
        isoCode: 'PN',
        countryAr: 'بيتكيرن',
    },
    {
        country: 'Poland',
        countryCode: 48,
        isoCode: 'PL',
        countryAr: 'بولندا',
    },
    {
        country: 'Portugal',
        countryCode: 351,
        isoCode: 'PT',
        countryAr: 'البرتغال',
    },
    {
        country: 'Puerto Rico',
        countryCode: '1-787, 1-939',
        isoCode: 'PR',
        countryAr: 'بورتوريكو',
    },
    {
        country: 'Qatar',
        countryCode: 974,
        isoCode: 'QA',
        countryAr: 'قطر',
    },
    {
        country: 'Reunion',
        countryCode: 262,
        isoCode: 'RE',
        countryAr: 'جمع شمل',
    },
    {
        country: 'Romania',
        countryCode: 40,
        isoCode: 'RO',
        countryAr: 'رومانيا',
    },
    {
        country: 'Russia',
        countryCode: 7,
        isoCode: 'RU',
        countryAr: 'روسيا',
    },
    {
        country: 'Rwanda',
        countryCode: 250,
        isoCode: 'RW',
        countryAr: 'رواندا',
    },
    {
        country: 'Saint Barthelemy',
        countryCode: 590,
        isoCode: 'BL',
        countryAr: 'سانت بارتيليمي',
    },
    {
        country: 'Saint Helena',
        countryCode: 290,
        isoCode: 'SH',
        countryAr: 'سانت هيلانة',
    },
    {
        country: 'Saint Kitts and Nevis',
        countryCode: '1-869',
        isoCode: 'KN',
        countryAr: 'سانت كيتس ونيفيس',
    },
    {
        country: 'Saint Lucia',
        countryCode: '1-758',
        isoCode: 'LC',
        countryAr: 'سانت لوسيا',
    },
    {
        country: 'Saint Pierre and Miquelon',
        countryCode: 508,
        isoCode: 'PM',
        countryAr: 'سانت بيير وميكلون',
    },
    {
        country: 'Saint Vincent and the Grenadines',
        countryCode: '1-784',
        isoCode: 'VC',
        countryAr: 'سانت فينسنت والغرينادين',
    },
    {
        country: 'Saint Martin',
        countryCode: 590,
        isoCode: 'MF',
        countryAr: 'سینٹ مارٹن',
    },
    {
        country: 'Sint Maarten',
        countryCode: '1-721',
        isoCode: 'SX',
        countryAr: 'سنٹ مارٹن',
    },
    {
        country: 'Samoa',
        countryCode: 685,
        isoCode: 'WS',
        countryAr: 'ساموآ',
    },
    {
        country: 'San Marino',
        countryCode: 378,
        isoCode: 'SM',
        countryAr: 'سان مارينو',
    },
    {
        country: 'Sao Tome and Principe',
        countryCode: 239,
        isoCode: 'ST',
        countryAr: 'ساو تومي وبرينسيب',
    },
    {
        country: 'Senegal',
        countryCode: 221,
        isoCode: 'SN',
        countryAr: 'السنغال',
    },
    {
        country: 'Serbia',
        countryCode: 381,
        isoCode: 'RS',
        countryAr: 'صربيا',
    },
    {
        country: 'Seychelles',
        countryCode: 248,
        isoCode: 'SC',
        countryAr: 'سيشل',
    },
    {
        country: 'Sierra Leone',
        countryCode: 232,
        isoCode: 'SL',
        countryAr: 'سيراليون',
    },
    {
        country: 'Singapore',
        countryCode: 65,
        isoCode: 'SG',
        countryAr: 'سنغافورة',
    },
    {
        country: 'Slovakia',
        countryCode: 421,
        isoCode: 'SK',
        countryAr: 'سلوفاكيا',
    },
    {
        country: 'Slovenia',
        countryCode: 386,
        isoCode: 'SI',
        countryAr: 'سلوفينيا',
    },
    {
        country: 'Solomon Islands',
        countryCode: 677,
        isoCode: 'SB',
        countryAr: 'جزر سليمان',
    },
    {
        country: 'Somalia',
        countryCode: 252,
        isoCode: 'SO',
        countryAr: 'الصومال',
    },
    {
        country: 'South Africa',
        countryCode: 27,
        isoCode: 'ZA',
        countryAr: 'جنوب أفريقيا',
    },
    {
        country: 'South Korea',
        countryCode: 82,
        isoCode: 'KR',
        countryAr: 'كوريا الجنوبية',
    },
    {
        country: 'South Sudan',
        countryCode: 211,
        isoCode: 'SS',
        countryAr: 'جنوب السودان',
    },
    {
        country: 'Spain',
        countryCode: 34,
        isoCode: 'ES',
        countryAr: 'إسبانيا',
    },
    {
        country: 'Sri Lanka',
        countryCode: 94,
        isoCode: 'LK',
        countryAr: 'سريلانكا',
    },
    {
        country: 'Sudan',
        countryCode: 249,
        isoCode: 'SD',
        countryAr: 'السودان',
    },
    {
        country: 'Suriname',
        countryCode: 597,
        isoCode: 'SR',
        countryAr: 'سورينام',
    },
    {
        country: 'Svalbard and Jan Mayen',
        countryCode: 47,
        isoCode: 'SJ',
        countryAr: 'سوالبرڈ اور جان ماین',
    },
    {
        country: 'Swaziland',
        countryCode: 268,
        isoCode: 'SZ',
        countryAr: 'إسواتيني',
    },
    {
        country: 'Sweden',
        countryCode: 46,
        isoCode: 'SE',
        countryAr: 'السويد',
    },
    {
        country: 'Switzerland',
        countryCode: 41,
        isoCode: 'CH',
        countryAr: 'سويسرا',
    },
    {
        country: 'Syria',
        countryCode: 963,
        isoCode: 'SY',
        countryAr: 'سوريا',
    },
    {
        country: 'Taiwan',
        countryCode: 886,
        isoCode: 'TW',
        countryAr: 'تايوان',
    },
    {
        country: 'Tajikistan',
        countryCode: 992,
        isoCode: 'TJ',
        countryAr: 'طاجيكستان',
    },
    {
        country: 'Tanzania',
        countryCode: 255,
        isoCode: 'TZ',
        countryAr: 'تنزانيا',
    },
    {
        country: 'Thailand',
        countryCode: 66,
        isoCode: 'TH',
        countryAr: 'تايلاند',
    },
    {
        country: 'Togo',
        countryCode: 228,
        isoCode: 'TG',
        countryAr: 'توغو',
    },
    {
        country: 'Tokelau',
        countryCode: 690,
        isoCode: 'TK',
        countryAr: 'توكيلاو',
    },
    {
        country: 'Tonga',
        countryCode: 676,
        isoCode: 'TO',
        countryAr: 'تونغا',
    },
    {
        country: 'Trinidad and Tobago',
        countryCode: '1-868',
        isoCode: 'TT',
        countryAr: 'ترينيداد وتوباغو',
    },
    {
        country: 'Tunisia',
        countryCode: 216,
        isoCode: 'TN',
        countryAr: 'تونس',
    },
    {
        country: 'Turkey',
        countryCode: 90,
        isoCode: 'TR',
        countryAr: 'تركيا',
    },
    {
        country: 'Turkmenistan',
        countryCode: 993,
        isoCode: 'TM',
        countryAr: 'تركمانستان',
    },
    {
        country: 'Turks and Caicos Islands',
        countryCode: '1-649',
        isoCode: 'TC',
        countryAr: 'جزر تركس وكايكوس',
    },
    {
        country: 'Tuvalu',
        countryCode: 688,
        isoCode: 'TV',
        countryAr: 'توفالو',
    },
    {
        country: 'U.S. Virgin Islands',
        countryCode: '1-340',
        isoCode: 'VI',
        countryAr: 'جزر العذراء الامريكية',
    },
    {
        country: 'Uganda',
        countryCode: 256,
        isoCode: 'UG',
        countryAr: 'أوغندا',
    },
    {
        country: 'Ukraine',
        countryCode: 380,
        isoCode: 'UA',
        countryAr: 'أوكرانيا',
    },
    {
        country: 'United Kingdom',
        countryCode: 44,
        isoCode: 'GB',
        countryAr: 'المملكة المتحدة',
    },
    {
        country: 'United States',
        countryCode: 1,
        isoCode: 'US',
        countryAr: 'الولايات المتحدة',
    },
    {
        country: 'Uruguay',
        countryCode: 598,
        isoCode: 'UY',
        countryAr: 'الأوروغواي',
    },
    {
        country: 'Uzbekistan',
        countryCode: 998,
        isoCode: 'UZ',
        countryAr: 'أوزبكستان',
    },
    {
        country: 'Vanuatu',
        countryCode: 678,
        isoCode: 'VU',
        countryAr: 'فانواتو',
    },
    {
        country: 'Vatican',
        countryCode: 379,
        isoCode: 'VA',
        countryAr: 'الفاتيكان',
    },
    {
        country: 'Venezuela',
        countryCode: 58,
        isoCode: 'VE',
        countryAr: 'فنزويلا',
    },
    {
        country: 'Vietnam',
        countryCode: 84,
        isoCode: 'VN',
        countryAr: 'فيتنام',
    },
    {
        country: 'Wallis and Futuna',
        countryCode: 681,
        isoCode: 'WF',
        countryAr: 'واليس وفوتونا',
    },
    {
        country: 'Western Sahara',
        countryCode: 212,
        isoCode: 'EH',
        countryAr: 'الصحراء الغربية',
    },
    {
        country: 'Yemen',
        countryCode: 967,
        isoCode: 'YE',
        countryAr: 'اليمن',
    },
    {
        country: 'Zambia',
        countryCode: 260,
        isoCode: 'ZM',
        countryAr: 'زامبيا',
    },
    {
        country: 'Zimbabwe',
        countryCode: 263,
        isoCode: 'ZW',
        countryAr: 'زيمبابوي',
    },
];
//# sourceMappingURL=index.js.map